<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CQp3yB/tc-custom/cover.jpg?1718739773205?1718755551247" alt="This image is the cover for the book Marriages are Made in India"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marriages are Made in India
      </h1>
      <p class="bookDescription body article font2">
        
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lakshmi Raj Sharma
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publerati, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef4df538